(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mkr-index"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pick(root) {
    (root || document).querySelectorAll('.mkr-tile').forEach(function (li) {
      var d = li.querySelector('[data-pool]');
      if (!d) return;
      var pool;
      try { pool = JSON.parse(d.textContent); } catch (e) { return; }
      if (!pool || !pool.length) return;
      var p = pool[Math.floor(Math.random() * pool.length)];
      var img = li.querySelector('.mkr-tile__img');
      if (img) { img.removeAttribute('srcset'); img.src = p.src; img.srcset = p.srcset; img.alt = p.alt; }
      var cap = li.querySelector('[data-cap]');
      if (cap) cap.textContent = p.t;
    });
  }
  if (document.readyState !== 'loading') pick(); else document.addEventListener('DOMContentLoaded', function () { pick(); });
  document.addEventListener('shopify:section:load', function (e) { pick(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
